import React from "react";

interface ForgotPasswordProps {}

export const ForgotPassword: React.FC<ForgotPasswordProps> = () => {
  return <div>Forgot PW here</div>;
};
